<template>
  <div class="text-widget">
    <div class="widget-header" v-if="title">
      <h3>{{ title }}</h3>
    </div>
    <div class="widget-content">
      <ul v-if="Array.isArray(body)">
        <li v-for="(item, index) in body" :key="index">
          {{ tConfig(item, lang) }}
        </li>
      </ul>
      <p v-else>{{ tConfig(body, lang) }}</p>
    </div>
  </div>
</template>

<script setup>
import { tConfig } from '../i18n/index.js';

defineProps({
  title: { type: String, default: '' },
  body: { type: [String, Array, Object], required: true },
  lang: { type: String, default: 'ca_es' }
});
</script>

<style scoped>
.text-widget {
  background: white;
  border-radius: 4px;
  padding: 16px 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  border: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.widget-header h3 {
  font-size: 0.85rem;
  font-weight: 600;
  color: #333;
  margin-top: 0;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-family: 'Source Sans Pro', sans-serif;
}

.widget-content {
  font-size: 0.875rem;
  color: #6b7280;
  line-height: 1.5;
}

.widget-content ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.widget-content li {
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
}

.widget-content li::before {
  content: "•";
  color: #21B7C9;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-right: 8px;
  flex-shrink: 0;
}

.widget-content p {
  margin: 0;
}
</style>
